import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=a997107a&"
import script from "./SidebarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarItem.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/Sidebar/SidebarItem.vue
// module id = null
// module chunks = 